import firebase from '../fb'
import router from '../router'
import db from '../db'
import { firestoreAction } from 'vuexfire'
import axios from "axios"

const state = {
  user:[],
  authenticated: false,
  id: '',
  user_record:{},
  perso: [],
  instant: [],
  verification:[]

};
const getters = {
  
  user: state => {
    
    return state.user;
  },
  auth: state => {
    return state.authenticated;
  },
  cfa: state => {
    
    return state.user.cfaBalance;
  },
  btc: state => {
    
    return state.user.btcBalance;
  },

  pin: state => {
    return state.user.pin;
  },
  eth: state => {
    return state.user.ethBalance;
  },
  ghs: state => {
    return state.user.ghsBalance;
  },
  pm: state => {
    return state.user.pmBalance;
  },

  usdt: state => {
    return state.user.usdtBalance;
  },

  instant: state => {
    return state.instant;
  },

  instant_test : state => {
    let obj = {}
    state.instant.forEach(element => {
           obj[`${element.id}`] = element
         });
        return obj
  },

  perso: state => {
    return state.perso;
  },
  verification: state => {
    return state.verification;
  },

};

const mutations = {

  SET_USER(state, setUser) {
    if (setUser) {
      state.authenticated = true,
        state.id = setUser.id;
        state.user_record = setUser.user
    } else {
      state.user = null
      state.authenticated = false
      state.id = null
      router.push('/login')
    }
  },
  destroyUser(state) {
    state.user = null,
      state.authenticated = false
    state.id = null
    router.push('/login')
  },

};

const actions = {
  init: firestoreAction( async context => {
    var user = await firebase.auth().currentUser;
    let id =user.uid
    return context.bindFirestoreRef('user', db.collection('users').doc(id));
  }),

  bind_perso:firestoreAction(context => {
    return context.bindFirestoreRef('perso', db.collection('perso').doc('hiropay_commands'));
  }),

  bind_instant:firestoreAction(context => {
    return context.bindFirestoreRef('instant', db.collection('instant'));
  }),
  bind_verification: firestoreAction(context => {
    let user = firebase.auth().currentUser;
    return context.bindFirestoreRef('verification', db.collection('verification').doc(user.uid));
  }),

  async login({commit, dispatch}, payload) {

    return new Promise((resolve, reject) => {
    firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(async (cred) => {
          const token  = await firebase.auth().currentUser.getIdToken(true)

          if (cred.user.emailVerified==true) {
            dispatch('setLoginInfo', {status: 'success', identifier:payload.email, ip_address: payload.ip_address})
            resolve(cred)
          }else{
            reject({token, message: 'not verified'});
            firebase.auth().signOut()
          }
        })
        .catch((err) => {
          reject(err)
          console.log(err);
          let message, title 
          switch (err.code) {
            case `auth/user-not-found`: title = "Compte inexistant" ; message = "Votre email n'est pas enrégistré sur HIROPAY!"
              break;
            case `auth/wrong-password`: title = "Mot de passe erroné" ; message =  "Email ou mot de passe erroné"
              break;
            case `auth/user-disabled`: title = "Compte desactivé" ; message =   " Votre compte est desactivé , Contactez le support pour plus de détails!"
              break;
            case `auth/invalid-email`: title = "Email mal écrit" ; message =  "Verifiez votre email et assurez vous qu'il n'y est pas d'espace au début ou à la fin!"
              break;
            case `auth/too-many-requests`: title = "trop de requetes pour cet utilisateur" ; message =  "veuillez reesayer plut tard!"
              break;
            default:
              break;
          }
          dispatch('setLoginInfo', {status: 'failed', error_message: title, identifier:payload.email, ip_address: payload.ip_address} )
          swal('erreur de connexion', message, "error", {
            button: "ok"
          })
          
        })
  })
  }
  ,
  async setLoginInfo ({context}, payload){
    console.log(payload);
    let api = 'https://hiropay-api.fly.dev'
    if (location.hostname === "localhost") {
      api = 'http://localhost:4000'
    }
    axios.post(`${api}/auth_pay/set_login_info`, payload).then((result)=> {
      console.log('login info set', result.data);
    })

  },

  checkUserStatus(context) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          if (user.emailVerified==true){
            context.dispatch('init',user.uid)
            resolve(user);
            var setUser = {
              id: user.uid,
              user: user
            };
            context.commit('SET_USER', setUser)
          }else{
            firebase.auth().signOut()
          }
        } else {
          firebase.auth().signOut()
          reject('not logged in');
        }
      });
    })
  },
  logout(context) {
    firebase.auth().signOut().then(function () {
      context.commit('destroyUser');
      router.push('/login')
      window.location.reload()
    }).catch(function (error) {
      // An error happened.
      window.location.reload()
    });
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}